import { createCrewLookupSelect } from './createCrewLookupSelect';

export const EmploymentStatusSelect = createCrewLookupSelect(
  'EmploymentStatusSelect',
  'employmentStatuses',
);
export default EmploymentStatusSelect;
